import React, { useEffect, useRef } from 'react'
import { Messages } from 'primereact/messages';
import { consultarTransaccionesAgrupadasCierreLote, consultarTransaccionesConDetalleMF, consultarTransaccionesDetalles} from '../services/transacciones.service';
import { useGlobalContext } from '../../shared/context/global.context';
import { usePresentacionContext } from '../context/presentacion.context';
import { HttpStatusCode } from 'axios';
import moment from 'moment';


const AlertasPresentacion = () => {
        const { presentacionesIniciadas } = useGlobalContext();
        
        const { presentacion,setDetailsTxDisponibles,
            setDetailsTxSeleccionadas,setShowDetailTransaction,setLotesPendientes,selectedProductoComercio,detailsTxMF} = usePresentacionContext();
        const messages = useRef<any>(null);
        useEffect(() => {
            (async () => {
                let resultDetailsTransacction;
                let filterTxD;
                if(selectedProductoComercio.grupoProductoId === 19){
                    if(!detailsTxMF) return
                    const hoy = moment(new Date())
                    filterTxD = detailsTxMF.transaccionesDisponibles.filter((detalle:any) => {
                        const fechaPresentacion = moment(detalle.fechaTransaccion)
                        const diferencia = moment(fechaPresentacion).diff(hoy,'days')
                        return Math.abs(diferencia) > 90
                    })
                }else{
                    resultDetailsTransacction   = await consultarTransaccionesDetalles(presentacion);
                    if (resultDetailsTransacction.status === HttpStatusCode.Ok) {
                        const hoy = moment(new Date())
                        if(selectedProductoComercio.grupoProductoId !== 19){
                            let txDetalles = resultDetailsTransacction.data.transaccionesDisponibles.flatMap((item:any) => item["detalles"])
                            filterTxD = txDetalles.filter((detalle:any) => {
                                const fechaPresentacion = moment(detalle.fecha_transaccion)
                                const diferencia = moment(fechaPresentacion).diff(hoy,'days')
                                return Math.abs(diferencia) > 90
                            })
                        }
                    }
                }

                if (filterTxD.length > 0 ) {
                    showInfo(`Recuerde que debe presentar las facturas para transacciones pendientes o no se le abonará la presentación mas nueva`);
                    if(selectedProductoComercio.grupoProductoId === 19){
                        setDetailsTxDisponibles(
                            detailsTxMF.transaccionesDisponibles
                          );
                          setDetailsTxSeleccionadas(
                            detailsTxMF.transaccionesSeleccionadas
                          );
                    }else{
                        setDetailsTxDisponibles(
                            resultDetailsTransacction.data.transaccionesDisponibles
                          );
                          setDetailsTxSeleccionadas(
                            resultDetailsTransacction.data.transaccionesSeleccionadas
                          );
                    }
                      setShowDetailTransaction(true);
                      setLotesPendientes(filterTxD)
                }
    
    
                const filterPresentacionesIni = presentacionesIniciadas.filter((item:number) => item != presentacion)
                filterPresentacionesIni.forEach(async (preCupon:number) => {
                    const result = await consultarTransaccionesAgrupadasCierreLote(preCupon)
                    if(result.data.transaccionesSeleccionadas.length > 0){
                        showInfo(`Existen transacciones asociadas en la(s) presentación/es [#${preCupon}]`)
                    } 
                });
            })()
        }, [])
    
    
    
        const showInfo = (message:string) => {
            messages.current.show([
                { severity: 'warn', detail: message, sticky: true }
            ]);
        }
    
        return (
            <Messages ref={messages}></Messages>
        )
}

export default AlertasPresentacion